import { useRef, useState, useCallback } from 'react';

import { isElectron } from 'services/env-service';
import { requestMediaAccess } from 'services/electron-service';

export const useAudioSupported = () => {
     return navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
}

export const useRecordAudio = ({ onRecorded, onError }) => {
     const audioSupported = useAudioSupported();
     const mediaRecorder = useRef(null);
     const [stream, setStream] = useState(null);
     const [isRecording, setIsRecording] = useState(false);

     const start = useCallback(async () => {
          if (!audioSupported) {
               onError({
                    message: 'Not supported'
               });
               return false;
          }

          const chunks = [];

          try {
               if (isElectron()) {
                    await requestMediaAccess('microphone');
               }
               const mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true });
               mediaRecorder.current = new MediaRecorder(mediaStream);
               setStream(mediaStream);

               const startedOn = Date.now();

               setIsRecording(true);
               mediaRecorder.current.start();
               mediaRecorder.current.ondataavailable = e => {
                    chunks.push(e.data);
               }

               mediaRecorder.current.onstop = () => {
                    mediaRecorder.current = null;
                    setStream(null);

                    const blob = new Blob(chunks, { 'type' : 'audio/webm' });
                    const details = {
                         duration: Math.round((Date.now() - startedOn) / 1000)
                    };

                    setIsRecording(false);
                    onRecorded({ blob, details });
               }
          } catch (e) {
               onError(e);
          }
     }, []);

     const stop = useCallback(() => {
          if (!isRecording || !mediaRecorder.current) {
               return;
          }

          mediaRecorder.current.stop();
          stream.getTracks().forEach(track => track.stop());
     }, [mediaRecorder, stream, isRecording]);

     return {
          start,
          stop,
          stream,
          isRecording,
          audioSupported
     };
}
